export * from './loading.component';


// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/loading/index.ts